import { CheckboxAdapter } from 'components/enhanced/form/adapters/CheckboxAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';
import { ISAPSettings } from './types';
import { movementReasonService } from 'features/inventory/movements/api/movement-reason.service';

interface SAPSettingsFormParams {
  settings: ISAPSettings;
  onSubmit: any;
}

const SAPSettingsForm = ({ settings, onSubmit }: SAPSettingsFormParams) => {
  const { t } = useTranslation();

  const [movementReasons, setMovementReasons] = useState<Option[]>([]);

  useEffect(() => {
    movementReasonService.getAllPaginated().then((res) => {
      setMovementReasons(res.results);
    });
  }, []);

  return (
    <div>
      {settings && (
        <EnhancedForm
          onSubmit={onSubmit}
          title={t('entities.tenant-settings.base-info')}
          autoStyleLayout
          columns={6}>
          <IdentityField
            gridSpan={6}
            name="enabled"
            label={t(`global.active`)}
            initialValue={settings.enabled}
            component={CheckboxAdapter}
            placeholder={t('global.active')}
            type="checkbox"
          />

          <IdentityField
            gridSpan={4}
            name="base_url"
            label={t(`entities.sap-settings.base_url`)}
            initialValue={settings.base_url}
            component={TextFieldAdapter}
            type="text"
          />

          <IdentityField
            gridSpan={2}
            name="sync_order_endpoint"
            label={t(`entities.sap-settings.sync_order_endpoint`)}
            initialValue={settings.sync_order_endpoint}
            component={TextFieldAdapter}
            type="text"
          />

          <IdentityField
            gridSpan={3}
            name="username"
            label={t(`entities.sap-settings.username`)}
            initialValue={settings.username}
            component={TextFieldAdapter}
            type="text"
          />

          <IdentityField
            gridSpan={3}
            name="password"
            label={t(`entities.sap-settings.password`)}
            initialValue={settings.password}
            component={TextFieldAdapter}
            type="text"
          />
        </EnhancedForm>
      )}
    </div>
  );
};

export default SAPSettingsForm;
